import styled, { css } from 'styled-components';
import walletIcon from '~/assets/icons/wallet.svg';
import { VehicleEngineType } from '~/shared';

const StyledIcon = styled.img.attrs({
	src: walletIcon,
})`
	width: 20px;
	height: 20px;
	transition: filter 0.25s ease;
`;

const StyledLabel = styled.div`
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #fff;
	transition:
		filter 0.25s ease,
		opacity 0.25s ease;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
`;

const StyledContainer = styled.div<{
	$disabled?: boolean;
	$engineType: VehicleEngineType;
}>`
	position: relative;
	width: ${(props) =>
		props.$engineType === VehicleEngineType.Petrol ? '200px' : '160px'};
	height: 40px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	background-color: #1f8034;
	transition: background-color 0.25s ease;
	user-select: none;

	${(props) =>
		props.$disabled
			? css`
					background-color: rgba(255, 255, 255, 0.05);

					${StyledLabel} {
						opacity: 0.5;
					}
			  `
			: css`
					&:hover {
						background-color: #ffffff;
						cursor: pointer;

						${StyledLabel}, ${StyledIcon} {
							filter: invert(100%);
						}
					}
			  `}
`;

export { StyledButtonContent, StyledContainer, StyledIcon, StyledLabel };
